import { StateArea } from '.';
import * as classNames from 'classnames';
import { Checkbox } from 'components/action';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppStore } from 'stores/AllStores';
import { StateAreaListPicker } from './StateAreaListPicker';
import { LoadingSpinner } from 'components/indicator';

// Styles
const s = require('./StateAreaList.css');

// Props
interface IStateListProps {
    store?: IAppStore;
}

// Component
@inject('store')
@observer
export class StateAreaList extends React.Component<IStateListProps, {}> {
    @computed private get areAllSelected(): boolean {
        const { state } = this.props.store;

        return (
            state.areasSearchedResults.length > 0 &&
            state.areasSearchedResults.length ===
                state.checkedAreasSearchedResultsLength
        );
    }

    public render() {
        // Destructure
        const { state } = this.props.store;

        // Render
        return (
            <div className={s.container}>
                <h2 className={s.stateName}>
                    {state.selectedState.name || state.selectedState.id}
                </h2>

                <div className={s.header}>
                    <div className={s.row}>
                        <div>Area codes</div>
                        <div>Leads count</div>
                        <div>Primary rep</div>
                        <div>Secondary rep</div>
                        <div className={s.selectCol}>
                            {state.areasSearchedResults.length > 0 && (
                                <Checkbox
                                    onChange={this.handleToggleAll(
                                        this.areAllSelected ? false : true
                                    )}
                                    className={s.selectAll}
                                    label={
                                        this.areAllSelected
                                            ? 'Deselect all'
                                            : 'Select all'
                                    }
                                    labelOnLeft={true}
                                    align="right"
                                    value="toggleall"
                                    checked={this.areAllSelected}
                                />
                            )}
                        </div>
                    </div>
                </div>

                {(state.selectedStateIsLoading && (
                    <div className={s.loading}>
                        <LoadingSpinner active={true} />
                    </div>
                )) ||
                    (state.areasSearchedResults.length > 0 && (
                        <div className={s.items}>
                            {state.areasSearchedResults.map((area, i) => (
                                <StateArea
                                    key={area.areaCode}
                                    onToggle={this.handleToggleArea}
                                    className={s.row}
                                    area={area}
                                />
                            ))}
                        </div>
                    )) || (
                        <div className={classNames(s.items, s.empty)}>
                            <p>
                                No areas found for this state matching criteria.
                            </p>
                        </div>
                    )}
            </div>
        );
    }

    private handleToggleArea = (areaCode: string) => {
        this.props.store.state.toggleAreaCheckbox(areaCode);
    };

    private handleToggleAll = (check: boolean) => (
        checked: boolean,
        value: any
    ) => {
        this.props.store.state.toggleAllAreaCheckboxes(check);
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/state/StateAreaList.tsx